import React, { FC, useEffect, useMemo, useState } from "react";
import "../css/jobPosition.css";
import "../css/jobPositionSm.css";
import JPSearch from "./jp_Search";
import { LinkIcon } from "../../../../assets-module/asset-configuration/icon/iconExporter/iconExporter";
import { useNavigate, useOutletContext } from "react-router-dom";
import { JobFilters } from "../../../../layout-module/layout-configuration/outlet/ts/jpOutlet";
import EmptyPosition from "../../../../component-module/component-services/card/job-filter/empty-job/ts/emptyPosition";
import { slugify } from "../../../../route-module/route-configuration/controller-route/ts/slugifyRoute";

import { getJobIndexApi, JobIndexItem } from "./jb.type"; 

const JobPosition: FC = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const { filters } = useOutletContext<{ filters: JobFilters }>();

  const [jobs, setJobs] = useState<JobIndexItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [page, setPage] = useState(1); //NOSONAR
  const size = 10;

  const onClickPos = (slug: string, code: string) => {
    navigate(`/career/position/${slugify(slug)}/code/${slugify(code)}`, {
      state: { code },
    });
  };

  useEffect(() => {
    let alive = true;

    const run = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await getJobIndexApi(page, size);

        if (!alive) return; //NOSONAR

        const items = res.data.data.items ?? [];
        setJobs(items);
      } catch (e: any) {
        if (!alive) return; //NOSONAR
        setError(e?.message ?? "Failed to load jobs");
        setJobs([]);
      } finally {
        if (!alive) return; //NOSONAR
        setLoading(false);
      }
    };

    run();
    return () => {
      alive = false;
    };
  }, [page]); 
  const filteredJobs = useMemo(() => {
    const keyword = search.trim().toLowerCase();

    return jobs.filter((job) => {
      const matchSearch =
        !keyword ||
        job.jobTitle.toLowerCase().includes(keyword) ||
        job.jobCode.toLowerCase().includes(keyword) ||
        job.departmentName.toLowerCase().includes(keyword);

      const fieldMap: Record<string, any> = {
        department: job.departmentName,
        level: job.jobLevelName,
        type: job.jobType,
        status: job.status,
      };

      const matchFilters = Object.entries(filters).every(([field, values]) => {
        if (values.size === 0) return true;
        return values.has(fieldMap[field]);
      });

      return matchSearch && matchFilters;
    });
  }, [jobs, search, filters]);

  const resultCount = filteredJobs.length;

  return (
    <main className="scl--jp-mai-con-st">
      <div className="scl--jmcs-abs-cont-st">
        <JPSearch value={search} onChange={setSearch} />
        <div className="scl--jpmcs-res-sh-st">
          <span>Job title ({resultCount})</span>
        </div>
      </div>

      {loading ? (
        <div style={{ padding: 16 }}>Loading…</div>
      ) : error ? ( //NOSONAR
        <div style={{ padding: 16 }}>{error}</div>
      ) : resultCount > 0 ? ( //NOSONAR
        <div className="scl--jmcs-lis-ite-ca-eac-st">
          {filteredJobs.map((job) => (
            <div //NOSONAR
              key={job.jobId}
              className="scl--jliceas-ite-st"
              onClick={() => onClickPos(job.jobId, job.jobCode)}
            >
              <h6>{job.jobTitle}</h6>
              <div className="scl--jis-loc-bo-co-st">
                <span>
                  {job.departmentName} • {job.jobType}
                </span>
                <LinkIcon />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <EmptyPosition />
      )}
    </main>
  );
};

export default JobPosition;